<script setup>

import {Link} from '@inertiajs/vue3';
import ImgMedia from '@/Components/Images/ImgMedia.vue';
import {inject} from "vue";

const route = inject('route');
const dayjs = inject('dayjs');

defineProps({
    blog: Object,
});

</script>
<template>
    <Link
        :href="route('public.blogs.show', { blog: blog.page_slug })"
        class="flex h-full flex-col"
    >
        <div class="relative aspect-[1/1] bg-gray-50">
            <ImgMedia
                v-if="blog.featured_image"
                :media="blog.featured_image"
                :sizes="{ '768px': '360px', default: '100vw' }"
                classes="absolute inset-0 h-full w-full object-cover"
            />
        </div>

        <div class=" lg:text-md flex flex-1 flex-col justify-between space-y-4 py-8 text-sm">
            {{ dayjs(blog.published_at).format('DD MMMM YYYY') }}
            <div class="text-2xl font-bold uppercase">
                {{ blog?.title }}
            </div>
        </div>
    </Link>
</template>
